import type { Card, ReviewRecord } from './types.js';

const STORAGE_VERSION = 1;
const CARDS_KEY = 'pinyin-flashcards:cards';
const REVIEWS_KEY = 'pinyin-flashcards:reviews';
const VERSION_KEY = 'pinyin-flashcards:version';

interface StoredState {
  version: number;
  cards: Card[];
  reviews: ReviewRecord[];
}

export function loadState(): StoredState {
  const versionRaw = localStorage.getItem(VERSION_KEY);
  const cardsRaw = localStorage.getItem(CARDS_KEY);
  const reviewsRaw = localStorage.getItem(REVIEWS_KEY);

  if (versionRaw === null || cardsRaw === null) {
    return { version: STORAGE_VERSION, cards: [], reviews: [] };
  }

  try {
    const version = JSON.parse(versionRaw) as number;
    const cards = JSON.parse(cardsRaw) as Card[];
    const reviews = reviewsRaw ? (JSON.parse(reviewsRaw) as ReviewRecord[]) : [];

    if (version !== STORAGE_VERSION) {
      // Simple migration: keep cards, drop old reviews if schema changed.
      return { version: STORAGE_VERSION, cards, reviews: [] };
    }

    return { version, cards, reviews };
  } catch {
    return { version: STORAGE_VERSION, cards: [], reviews: [] };
  }
}

export function saveState(cards: Card[], reviews: ReviewRecord[]): void {
  localStorage.setItem(VERSION_KEY, JSON.stringify(STORAGE_VERSION));
  localStorage.setItem(CARDS_KEY, JSON.stringify(cards));
  localStorage.setItem(REVIEWS_KEY, JSON.stringify(reviews));
}
